// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2n5at","footer":"ModalCreateQualiphyProcedure_footer__3x6sQ","additionData":"ModalCreateQualiphyProcedure_additionData__2d6E_"};